// Formateadores numericos compartidos del storefront (formato es-VE: 1.000,00).
// Todos los montos en UI deben pasar por fmtMonto para mantener el separador de
// miles (punto) y decimal (coma) consistente.

// Monto monetario con 2 decimales: 100000 -> "100.000,00".
export const fmtMonto = (n) =>
  (Number(n) || 0).toLocaleString('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// Entero / cantidad sin decimales: 100000 -> "100.000".
export const fmtInt = (n) => (Number(n) || 0).toLocaleString('es-VE');

// Cantidad flexible (hasta 3 decimales, sin ceros a la derecha): 1000 -> "1.000".
export const fmtCant = (n) =>
  (Number(n) || 0).toLocaleString('es-VE', { maximumFractionDigits: 3 });
